import React from 'react'

export default function MessageBox() {
  return (
    <div className="">
      <h1>MessageBox</h1>
    </div>
  )
}